import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { State } from 'src/app/app.reducer';
import * as seatActions from '../actions/seat.actions';
import * as fromReducers from '../selectors/seats.selectors';
import {
  ICancelSeatRequestService,
  ReservationSeat,
  ReserveSeatConfirmation,
  ReserveSeatRequestService,
  SeatMap
} from 'src/app/core/models/seat.model';

@Injectable({
  providedIn: 'root'
})
export class SeatsService {
  constructor(private store: Store<State>) {}

  getSeatMapInfo(): Observable<SeatMap> {
    return this.store.pipe(select(fromReducers.getSeatMap));
  }

  getLoadingReserveSeat(): Observable<boolean> {
    return this.store.pipe(select(fromReducers.getLoadingReserveSeat));
  }

  dispatchSaveSeatsOption(seatListToReserve: ReservationSeat) {
    this.store.dispatch(seatActions.SaveSeatSelection({ seatListToReserve: seatListToReserve }));
  }

  dispatchRemoveSeatsOption(seatNumber: string, seatName: string, segment: string) {
    this.store.dispatch(
      seatActions.RemoveSeatSelection({ seatNumber: seatNumber, seatName: seatName, segment })
    );
  }

  getSeatListToReserve() {
    return this.store.pipe(select(fromReducers.getSeatListToReserve));
  }

  getReserveSeatResult(): Observable<ReserveSeatConfirmation> {
    return this.store.pipe(select(fromReducers.getReserveSeatResult));
  }

  dispatchShowSeatMap(): void {
    return this.store.dispatch(seatActions.showSeatMap());
  }

  dispatchHideSeatMap(): void {
    return this.store.dispatch(seatActions.hideSeatMap());
  }

  dispatchSeatMapSuccess(seatMap: SeatMap): void {
    return this.store.dispatch(seatActions.GetSeatMapSuccess({ seatMap }));
  }

  dispatchSeatMapFailed(error: string): void {
    return this.store.dispatch(seatActions.GetSeatMapFailed({ error }));
  }

  dispatchReserveSeat(reserveSeatRequestService: ReserveSeatRequestService): void {
    return this.store.dispatch(seatActions.ReserveSeat({ reserveSeatRequestService }));
  }

  dispatchCancelSeat(gds: string, cancelSeatRequestService: ICancelSeatRequestService): void {
    return this.store.dispatch(seatActions.CancelSeat({ gds, cancelSeatRequestService }));
  }
}
